import { toNumberOrZero, transformAsCurrency } from '~/utils/functions';
import { calculaValorIpi } from '../auxiliares/calculaValorIpi';

export function procedureSubtotais(itens: any[]) {
  let Total_Tab_Liq = 0;
  let Total_Tab = 0;
  let Ipi = 0;
  let Total_IPI = 0;
  let Credito_ICMS = 0;
  let Total_Nota_Fiscal = 0;
  let Total_ICMS_ST = 0;
  let Total_ST_FCP = 0;

  // eslint-disable-next-line no-restricted-syntax
  for (const item of itens) {
    if (item.qtd_entrada > 0) {
      // Total Tabela Liquido  ==> Total dos itens sem IPI ....
      Total_Tab_Liq += transformAsCurrency(item?.val_tabela_liq || 0);
      Total_Tab += transformAsCurrency(item?.val_total || 0);
      // Total IP;
      Ipi = calculaValorIpi(
        transformAsCurrency(item?.val_total || 0),
        transformAsCurrency(item?.val_tabela_liq || 0),
        transformAsCurrency(item?.val_ipi || 0),
      );
      Total_IPI += toNumberOrZero(item?.val_ipi * item?.qtd_entrada);
      // ICMS ST
      Total_ICMS_ST += transformAsCurrency(item.val_icms_st || 0);
      Total_ST_FCP += transformAsCurrency(item.val_tot_st_fcp || 0);
      // Crédito ICMS
      Credito_ICMS += transformAsCurrency(item?.val_icms || 0);
    }

    Total_Nota_Fiscal =
      Total_Tab_Liq + Total_IPI + Total_ICMS_ST + Total_ST_FCP;
  }
  return {
    Total_Tab,
    Total_IPI,
    Credito_ICMS,
    Total_Nota_Fiscal,
    Total_ICMS_ST,
  };
}
